module.exports = __webpack_public_path__ + "static/media/customer.9182ae34.svg";